var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.93848 6.46881L9.00098 11.5313L14.0635 6.46881","stroke":"black","strokeWidth":"1.00189","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDownInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
